import Vue from 'vue';

// Domain
import {
  InvestmentProductFundTypeStateManager,
} from '../../domain/state/investment-product-fund-type-state-manager';
import InvestmentProductFundTypeState from '../../domain/state/investment-product-fund-type-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class InvestmentProductFundTypeVueStateManager implements
  InvestmentProductFundTypeStateManager {
  // eslint-disable-next-line max-len
  private _state: InvestmentProductFundTypeState = Vue.observable<InvestmentProductFundTypeState>(new InvestmentProductFundTypeState());

  private readonly observers: Observer[] = [];

  get state(): InvestmentProductFundTypeState {
    return this._state;
  }

  set state(value: InvestmentProductFundTypeState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<InvestmentProductFundTypeState>) {
    type Keys = keyof InvestmentProductFundTypeState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
